export default "__VITE_ASSET__0UjjJ6i4__"